import clsx from 'clsx';

import { pdvColor, scoreColor } from '../tokens';
import { useStyles } from './styles';

interface ScoreBarProps {
  /** 0–100 */
  pct: number;
  /** 'score' colours by completeness; 'neutral' is grey (dismissed attributes) */
  tone?: 'score' | 'neutral';
  /** fixed track width; fills its cell when left out */
  width?: number | string;
  className?: string;
}

/** The completeness bar used across PDV. A non-zero value always shows a nub. */
export const ScoreBar = ({
  pct,
  tone = 'score',
  width = '100%',
  className
}: ScoreBarProps) => {
  const classes = useStyles();
  const fill = tone === 'neutral' ? pdvColor.borderStrong : scoreColor(pct);

  return (
    <span
      className={clsx(classes.track, className)}
      style={{ width }}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}>
      {pct > 0 && (
        <span
          className={classes.fill}
          style={{ width: `max(8px, ${pct}%)`, background: fill }}
        />
      )}
    </span>
  );
};
